var _defs, _path, _g, _path2, _path3, _path4, _path5, _path6, _circle, _circle2, _path7, _path8, _path9, _path0, _path1, _path10, _circle3, _circle4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNopickups(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 186,
    height: 126,
    viewBox: "0 0 186 126",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .cls-2{fill:#e6e6e6}.cls-4{fill:#ffb8b8}.cls-5{fill:#2f2e41}.cls-6{fill:#707079}.cls-7{fill:#fff}.cls-8{fill:#3f3d56}\n        "))), /*#__PURE__*/React.createElement("g", {
    id: "Group_16217",
    "data-name": "Group 16217",
    transform: "translate(-1677 -1045)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_5703",
    "data-name": "Rectangle 5703",
    transform: "translate(1677 1045)",
    style: {
      fill: "none"
    },
    d: "M0 0h186v126H0z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_16216",
    "data-name": "Group 16216",
    transform: "translate(1474.148 997.374)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_19897",
    "data-name": "Path 19897",
    className: "cls-2",
    d: "M354.407 184.663a56.734 56.734 0 0 0-3.973-49.881l-90.568 12.54 86.793-18.088c-36.579-45.615-107.776-15.359-100.913 42.233z",
    transform: "translate(-24.421 -44.791)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_5695",
    "data-name": "Rectangle 5695",
    transform: "translate(224.659 115.072)",
    style: {
      fill: "#a7eeff"
    },
    d: "M0 0h109.321v48.186H0z"
  }), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_16216-2",
    "data-name": "Group 16216",
    transform: "translate(212.852 47.626)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_19898",
    "data-name": "Path 19898",
    className: "cls-4",
    d: "M455.186 296.652c1.388 1.078 1.9 1.426 2.191 1.382 14.325 4.172 1.767 9.06-5.193.762z",
    transform: "translate(-393.072 -235.113)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19899",
    "data-name": "Path 19899",
    className: "cls-4",
    d: "M272.951 472.7v9.8l7.051-.392-1.959-10.186z",
    transform: "translate(-258.107 -367.062)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19900",
    "data-name": "Path 19900",
    className: "cls-4",
    d: "M410.065 472.7v9.8l-7.052-.392 1.959-10.186z",
    transform: "translate(-356.046 -367.062)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19901",
    "data-name": "Path 19901",
    className: "cls-5",
    d: "m263.682 269.287 10.577-.392c24.4 25.581 15.173 19.746 14.495 54.846l-12.928-3.918 2.742-24.289s.723-.482.123-.493c-3.753 1.29-6.492-14.68-14.618-12.826-9.247-.442-10.753 13.276-14.495 13.32l2.742 24.289-12.928 3.918c-1.448-38.571-8.542-29.858 14.495-54.846z",
    transform: "translate(-231.209 -214.181)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19902",
    "data-name": "Path 19902",
    className: "cls-5",
    d: "M229.654 495.943s-1.567-3.134-3.526-1.567-6.66 6.268-6.66 6.268-11.361 5.093-4.309 8.227 12.928-4.309 12.928-4.309c6.717-1.4 10.591-2.3 7.029-9.624-2.023.875-4.884 1.888-5.462 1.005z",
    transform: "translate(-212.852 -383.641)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19903",
    "data-name": "Path 19903",
    className: "cls-5",
    d: "M402.863 495.943s1.567-3.134 3.526-1.567 6.66 6.268 6.66 6.268 11.361 5.093 4.309 8.227-12.928-4.309-12.928-4.309c-6.716-1.4-10.59-2.3-7.029-9.624 2.022.875 4.884 1.888 5.462 1.005z",
    transform: "translate(-350.803 -383.641)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19904",
    "data-name": "Path 19904",
    className: "cls-4",
    d: "M344.155 69.918c-.583 9.752-13.893 8.894-14.1 0 .579-9.753 13.889-8.894 14.1 0z",
    transform: "translate(-301.105 -59.144)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19905",
    "data-name": "Path 19905",
    className: "cls-4",
    d: "M345.913 108.283c3.427 10.358-4.664 4.719 6.66 12.928l4.309-8.619s-3.134-1.175-2.742-5.485z",
    transform: "translate(-313.049 -92.417)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19906",
    "data-name": "Path 19906",
    className: "cls-6",
    d: "m325.28 127.532-11.68-2.665c.329 7.041-7.186 5.624-8.5 2.082l-11.165 6.46c4.686 17.454 3.5 18.174-2.742 29.382-2.382 2.175 1.18 3.422 4.281 2.231 2.365-1.46 3.566-2.757 6.1-2.427 11.975 2.494 21.944 3.082 23.522 2.108.57-.808-.011-37.03.184-37.171z",
    transform: "translate(-271.262 -105.775)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19907",
    "data-name": "Path 19907",
    className: "cls-6",
    d: "M418.875 135.938a15.437 15.437 0 0 0 2.41-.949c5.871-.1 9.811 39.393 10.126 40.516l-3.918 2.742-6.268-16.062z",
    transform: "translate(-367.99 -113.395)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19908",
    "data-name": "Path 19908",
    className: "cls-4",
    d: "M307.845 322.021c.2 1.478.541 18.082 6.489 10.326.78-5.658-1.873-7.348-2.571-11.109z",
    transform: "translate(-284.383 -253.621)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19909",
    "data-name": "Path 19909",
    className: "cls-6",
    d: "m297.593 157.419-1.2-.665c-3.218-.106-2.2 8.413-3.565 14.651-1.112 7.267-.8 15.281.509 25.995.114 3.931 7.156 1.455 8.174 1.154 0 0-2.35-16.062-1.175-18.8s-2.743-22.335-2.743-22.335z",
    transform: "translate(-272.564 -129.78)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19910",
    "data-name": "Path 19910",
    className: "cls-5",
    d: "M340.091 51.564a8.4 8.4 0 0 0-4.781-3.655l-1.462 1.169.568-1.364a7.746 7.746 0 0 0-1.445-.083l-1.315 1.691.544-1.633c-5.643.606-8.982 7.085-6.053 11.618.452-1.389 1-2.692 1.453-4.081a4.111 4.111 0 0 0 1.071.005l.55-1.283.154 1.229c1.7-.149 4.232-.474 5.848-.773l-.157-.942.94.783c.495-.114.789-.217.765-.3 1.2 1.937 2.392 3.175 3.594 5.112.456-2.729 1.261-5.001-.274-7.493z",
    transform: "translate(-297.35 -47.626)"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_5696",
    "data-name": "Rectangle 5696",
    className: "cls-7",
    transform: "translate(290.456 120.863)",
    d: "M0 0h34.175v16.211H0z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_5697",
    "data-name": "Rectangle 5697",
    className: "cls-2",
    transform: "translate(296.92 124.256)",
    d: "M0 0h21.25v1.944H0z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_5698",
    "data-name": "Rectangle 5698",
    className: "cls-2",
    transform: "translate(296.92 127.996)",
    d: "M0 0h21.25v1.944H0z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_5699",
    "data-name": "Rectangle 5699",
    className: "cls-2",
    transform: "translate(296.92 131.736)",
    d: "M0 0h21.25v1.944H0z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_19911",
    "data-name": "Path 19911",
    className: "cls-7",
    d: "m635.059 456.689-1.112-1.925-1.111-1.926-1.112 1.926-1.112 1.925h1.194v5.575h2.058v-5.575z",
    transform: "translate(-314.675 -305.067)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_590",
    "data-name": "Ellipse 590",
    className: "cls-8",
    cx: 9.153,
    cy: 9.153,
    r: 9.153,
    transform: "translate(326.838 146.1)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_591",
    "data-name": "Ellipse 591",
    className: "cls-2",
    cx: 4.057,
    cy: 4.057,
    r: 4.057,
    transform: "translate(333.6 151.197)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Path_19912",
    "data-name": "Path 19912",
    className: "cls-8",
    d: "m653.156 509.033 19.971 8.321-.624 1.976-11.494-1.3-19.451-8.63 10.818 1.248z",
    transform: "translate(-322.939 -347.382)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Path_19913",
    "data-name": "Path 19913",
    className: "cls-8",
    d: "m704.672 240.125 24.838-81.477 6.049-10.742.021-.1a5.836 5.836 0 0 0-.629-3.966 3.561 3.561 0 0 0-2.405-1.515c-3.338-.626-10.806-.934-11.123-.947h-.06l-.059.008c-.2.028-4.977.725-6.056 4.893l-5.193 9.451-.02.067-23.507 77.283 1.294.394 23.487-77.216 5.21-9.482.021-.087c.763-3.136 4.41-3.87 4.9-3.954.763.033 7.782.345 10.861.922a2.229 2.229 0 0 1 1.529.936 4.382 4.382 0 0 1 .445 2.85l-6.012 10.676-.022.07-24.859 81.548z",
    transform: "translate(-356.834 -70.528)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_5700",
    "data-name": "Rectangle 5700",
    className: "cls-8",
    transform: "rotate(-79.762 232.043 -163.024)",
    d: "M0 0h1.352v18.229H0z"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_5701",
    "data-name": "Rectangle 5701",
    className: "cls-8",
    transform: "rotate(-78.465 238.446 -160.322)",
    d: "M0 0h1.352v18.178H0z"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_5702",
    "data-name": "Rectangle 5702",
    className: "cls-8",
    transform: "rotate(-74.03 253.989 -164.15)",
    d: "M0 0h1.352v18.087H0z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "Path_19914",
    "data-name": "Path 19914",
    className: "cls-8",
    d: "m727.4 453.863.493-1.259-16.878-6.609-.829-8.974 15.753 5.884 5.1 7.384 1.113-.769-5.345-7.734L708.64 435l1.1 11.95z",
    transform: "translate(-373.485 -291.634)"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_592",
    "data-name": "Ellipse 592",
    className: "cls-8",
    cx: 9.153,
    cy: 9.153,
    r: 9.153,
    transform: "translate(350.624 154.838)"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_593",
    "data-name": "Ellipse 593",
    className: "cls-2",
    cx: 4.057,
    cy: 4.057,
    r: 4.057,
    transform: "translate(358.113 160.351)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNopickups);
export default __webpack_public_path__ + "static/media/nopickups.9b60d92037679db568f9746cd7295599.svg";
export { ForwardRef as ReactComponent };